module.exports = __webpack_public_path__ + "static/media/balance.5bb38672.png";